import getRewardsPointsStore from '../store/rewardsPointsStore';

export default function hasRewardsPanelOpened(accountKey: string): boolean {
    return getRewardsPointsStore().panelOpenedByAccount[accountKey] === true;
}
